/**
 * Feature flag names
 *
 * Naming convention example:
 * {
 *   viberNames: 'la_viber_images',
 *   slSettingsPage: 'la_sl_settings-page',
 *   cerberusBlackLists: 'la_cerberus_black-lists',
 * }
 *
 * (just remove the prefix and convert snake case to camel case)
 */

import { deepFreeze } from '@mw/helpers';

export const REQUEST_FEATURE_FLAGS_DEBOUNCE_TIMEOUT = 5000;

export const FF = deepFreeze({});
